import __request__ from "routing/request";
export function migrate(remoteconfiguration) {
  return __request__("POST", "/remote-reindex-migration/remoteReindex", remoteconfiguration, {}, {
    "Accept": ["application/json"]
  });
}
export function status(migrationID) {
  return __request__("GET", `/remote-reindex-migration/status/${migrationID}`, null, {}, {
    "Accept": ["application/json"]
  });
}
